import React from 'react';
import PropType from 'prop-types';

const ModalFooter = ({ children, className }) => (
    <div className={`tr-modal-footer py-3 px-5 ${className}`}>{children}</div>
);

ModalFooter.propTypes = {
    children: PropType.node.isRequired,
    className: PropType.string
};

export default ModalFooter;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/modals/modal-footer.jsx